<template>
  <div>
    <a-modal
      title="操作"
      style="top: 20px;"
      :width="1000"
      v-model="visible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel1"
      :maskClosable="false"
    >
      <a-form :form="form" :class="status == 1 ? 'readyOnly':''">
        <a-row :gutter="16">
          <a-form-item style="display:none">
            <a-input v-decorator="['templateId']"/>
          </a-form-item>
          <a-col :span="8">
            <a-form-item label="模板名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['templateName',{ rules: [{ required: true, message: '请输入模板名称' }] }]"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  v-decorator="['installationType',{ rules: [{ required: true, message: '请选择安装类别' }] }]"  @change="handleOrder">
                <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  v-decorator="['orderType',{ rules: [{ required: true, message: '请选择订单类型' }] }]">
                <a-select-option  v-for="type in restaurantTypes1" :key="type.orderTypeId">{{type.typeName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="margin-bottom: 20px">
          <a-col :span="24" style="text-align: right">
            <a-button style="margin-right: 8px" type="primary" @click="getAdd">添加</a-button>
            <a-button style="margin-right: 8px" type="primary" @click="deploy1">预览</a-button>
            <span v-if="course == 1">
              <a-button v-if="!buttonShow" type="primary" @click="handleRank">排序</a-button>
              <span v-if="buttonShow">
                <a-button type="primary" @click="handleRankOk" style="margin-right: 8px" ghost>确定</a-button>
                <a-button type="dashed" @click="handleRankNo">取消</a-button>
              </span>
            </span>
          </a-col>
        </a-row>
        <a-table
          size="default"
          ref="table"
          rowKey="id"
          :columns="column"
          :dataSource="soteData"
          bordered
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record" v-if="buttonShow">
            <a-icon type="arrow-up" style="color:#1890ff;cursor: pointer;margin-right: 15px" @click="onUpItem(record)"/>
            <a-icon type="arrow-down" style="color:#1890ff;cursor: pointer" @click="onDownItem(record)"/>
            <!--<a-button type="primary" style="margin-right: 5px" @click="onUpItem(record)">上移</a-button>-->
            <!--<a-button type="primary" @click="onDownItem(record)">下移</a-button>-->
          </span>
          <span slot="installationType" slot-scope="text, record">
           <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installationType == type.code">{{type.label}}</td>
        </span>
          <span slot="isBack" slot-scope="text, record">
          {{ text | isTrueFilter }}
        </span>
          <span slot="isMust" slot-scope="text, record">
          {{ text | isTrueFilter }}
        </span>
          <span slot="fieldType" slot-scope="text, record">
          {{ text | fieldFilter }}
        </span>
          <span slot="isForbidden" slot-scope="text, record">
          {{ text | statuFilter }}
        </span>
          <span slot="fieldValue" slot-scope="text, record">
         <td v-for="type in data2" :key="type.dictType" v-if="record.fieldValue == type.dictType">{{type.dictName}}</td>
        </span>
        </a-table>
      </a-form>
    </a-modal>
    <a-modal
      title="添加"
      style="top: 20px;"
      v-model="aisible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit1"
      :maskClosable="false"
    >
      <a-form :form="form">
        <a-form-item label="安装信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            mode="multiple"
            v-model="installList"
            @change="handChange1"
          >
            <a-select-option  v-for="type in list1" :key="type.id">{{type.installationInfoName}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="预览"
      style="top: 20px;"
      v-model="cisible"
      :width="1000"
      :confirmLoading="confirmLoading"
      @cancel="handleClose1"
      :footer = false
    >
      <div class="table-page-search-wrapper">
        <a-form :form="form" layout="inline">
          <a-row :gutter="16">
            <a-col :span="12" v-for="item in data1">
              <a-form-item :label="item.installationInfoName" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-if="item.fieldType == 0">
                  <a-select-option  v-for="type in item.installTypeValues" :key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
                <a-input autocomplete="off" v-else-if="item.fieldType == 1"/>
                <span v-else-if="item.fieldType == 3">
                  <span>
                    <a-select show-search option-filter-prop="children" :filter-option="filterOption">
                      <a-select-option  v-for="type in item.installTypeValues" :key="type.dictValue">{{type.dictLabel}}</a-select-option>
                    </a-select>
                  </span>
                  <!--<span>-->
                    <!--<a-input  autocomplete="off"/>-->
                  <!--</span>-->
                </span>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>

import { STable } from '@/components'
import { updateSort,getInfoList,getOrderTypeList,fieldType,statuType,isTrueType,getList,InfoList,save,update,getSelectList,updateITI } from '@/api/basicdatas/OrderTemplate'
import pick from 'lodash.pick'
import {getDictMap} from "../../../utils/dict"
import AFormItem from "ant-design-vue/es/form/FormItem";

export default {
  name: "NoticeadModel",
  components: {
    AFormItem,
    STable,
  },
  data () {
    return {
      visible: false,
      aisible: false,
      cisible: false,
      labelCol1: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol1: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      form1: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      // 表头
      column:[],
      columns: [
        {
          title: '序号',
          dataIndex: 'sort',
          align:'center'
        },
        {
          title: '状态',
          dataIndex: 'isForbidden',
          scopedSlots: { customRender: 'isForbidden' },
          align:'center'
        },
        {
          title: '字段名称',
          dataIndex: 'installationInfoName',
          align:'center'
        },
        {
          title: '字段类型',
          dataIndex: 'fieldType',
          scopedSlots: { customRender: 'fieldType' },
          align:'center'
        },
        {
          title: '最近修改时间',
          dataIndex: 'updateTime',
          align:'center'
        },
        {
          title: '操作人',
          dataIndex: 'updateBy',
          align:'center'
        }
      ],
      columns2:[
        {
          title: '序号',
          dataIndex: 'sort',
          align:'center'
        },
        {
          title: '操作',
          width:60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '状态',
          dataIndex: 'isForbidden',
          scopedSlots: { customRender: 'isForbidden' },
          align:'center'
        },
        {
          title: '字段名称',
          dataIndex: 'installationInfoName',
          align:'center'
        },
        {
          title: '字段类型',
          dataIndex: 'fieldType',
          scopedSlots: { customRender: 'fieldType' },
          align:'center'
        },
        {
          title: '最近修改时间',
          dataIndex: 'updateTime',
          align:'center'
        },
        {
          title: '操作人',
          dataIndex: 'updateBy',
          align:'center'
        }
      ],
      soteData: [], // 排序
      data1: [], // 原数据
      data2: [],
      list1:[],
      list2:[],
      fieldType,
      statuType,
      isTrueType,
      course:0,
      restaurantTypes:[],
      restaurantTypes1:[],
      array1:[],
      installList:[],
      buttonShow:false,
      templateId:'',
      trueArr:[],
      status:0,
    }
  },
  beforeCreate () {
  },
  filters: {
    isTrueFilter (value) {
      return isTrueType[value]
    },
    fieldFilter (value) {
      return fieldType[value]
    },
    statuFilter (value) {
      return statuType[value]
    },
  },
  async created () {
    this.restaurantTypes = [];
    this.restaurantOperTypeMap = await getDictMap('install_type');
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({code: key, label: value})
    })
    getList().then(res=>{
      this.data2=res.rows
    })
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    add() {
      this.form.resetFields()
      this.visible = true
      this.buttonShow = false
      this.data1 = []
      this.soteData = []
      this.course=0
      this.column = this.columns
      // console.log(this.column)
    },
    edit(record,status) {
      // console.log(record)
      this.status = status
      this.mdl = Object.assign(record)
      this.visible = true
      this.buttonShow = false
      this.templateId = record.templateId
      this.course = 1
      this.data1 = []
      this.soteData = []
      this.column = this.columns
      // 添加页面的数据
      getInfoList(record.templateId).then(res => {
        // console.log(res.data)
        if(res.data == null){
          this.data1 = []
          this.installList = []
          this.soteData = []
        }else{
          for(let i=0;i<res.data.installationInfoList.length;i++){
            this.data1.push(res.data.installationInfoList[i])
          }
          this.soteData = res.data.installationInfoList
          // let arrList = []
          // for(let item of this.data1){
          //   // console.log(item)
          //   arrList.push(item.id)
          // }
          // this.installList = arrList
          // console.log(this.installList)
        }
      })
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.mdl,'sort','templateId','installationType','orderType','templateName'))
      })
      // 订单类型
      getOrderTypeList(record.installationType).then(res => {
        // console.log(res)
        this.restaurantTypes1 = res.rows
      })
    },
    // 预览
    deploy(record){
      this.cisible = true
      this.course = 2
      // console.log(record.templateId)
      getInfoList(record.templateId).then(res => {
        // console.log(res.data)
        if(res.data == null){
          this.data1 = []
          this.installList = []
        }else{
          this.data1 = res.data.installationInfoList
          // console.log('模板table',this.data1)
          // let arrList = []
          // for(var item of this.data1){
          //   arrList.push(item.id)
          // }
          // this.installList = arrList
          // console.log(this.installList)
        }
      })
    },
    deploy1(){
      this.visible = false
      if(this.course == 1){
        this.deploy(this.mdl)
        this.course = 1
      }else{
        this.course = 0
        this.cisible = true
      }
    },
    handleClose1(){
      if(this.course == 2){
        this.visible = false
      }else{
        this.visible = true
      }
    },
    // 添加
    getAdd(){
      console.log(this.soteData)
      this.installList = []
      this.list1 = []
      this.aisible = true
      for(let i of this.soteData){
        console.log(i)
        this.installList.push(i.id)
      }
      InfoList().then(res => {
        console.log(res.rows)
        for(let i of res.rows){
          if(i.forbidden == 0){
            this.list1.push(i)
          }
        }
        // this.list1 = res.rows
      })
    },
    handChange1(value){
      // console.log(`selected ${value}`);
      this.array1 = value
    },
    // 添加确定
    handleSubmit1(){
      let that = this
      this.data1 = []
      this.soteData = []
      // console.log(this.array1)
      if(this.course == 0){
        getSelectList({'ids':this.array1}).then(res=>{
          for(let i=0;i<res.rows.length;i++){
            this.data1.push(res.rows[i])
          }
          this.soteData = res.rows
          this.aisible = false
        })
      }else if(this.course == 1){
        let values = {}
        let array1 = this.array1
        let arr = []
        if( array1.length != 0){
          for (var item of array1){
            let ster = {}
            // console.log(item)
            ster.infoId = item
            ster.templateId = that.mdl.templateId
            arr.push(ster)
          }
        }else{
          arr.push({templateId:that.mdl.templateId})
        }
        values.installationInfoListonInfo = arr
        updateITI(values).then(res=>{
          getInfoList(that.mdl.templateId).then(res => {
            if(res.data == null){
              this.soteData = []
            }else{
              for(let i=0;i<res.data.installationInfoList.length;i++){
                this.data1.push(res.data.installationInfoList[i])
              }
              this.soteData = res.data.installationInfoList
            }
          })
          this.aisible = false
        })
      }
    },
    handleCancel1(){
      // this.installList = []
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          if (this.course == 0){
            let array1 = this.array1
            let arr = []
            for (var item of array1){
              let ster = {}
              // console.log(item)
              ster.infoId = item
              arr.push(ster)
            }
            delete values.infoId
            values.installationTemplateInfoList = arr
            save(values).then(res => {
              // console.log(values)
              if (res.code === 0) {
                this.$message.success('保存成功')
                // this.installList = []
                this.$emit('ok',1)
                this.visible = false
              } else {
                this.$message.error(res.msg)
              }
            }).catch(() => {
              this.$message.error('系统错误，请稍后再试')
            }).finally(() => {
              this.confirmLoading = false
            })
          }else if (this.course == 1){
            update(values).then(res => {
              // console.log(values)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok',2)
                this.visible = false
              } else {
                this.$message.error(res.msg)
              }
            }).catch(() => {
              this.$message.error('系统错误，请稍后再试')
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    // 订单类型下拉
    handleOrder(value){
      this.queryParam.orderType = ''
      this.form.setFieldsValue({
        orderType:undefined
      })
      getOrderTypeList(value).then(res => {
        // console.log(res)
        this.restaurantTypes1 = res.rows
      })
    },
    // 排序
    handleRank(){
      this.buttonShow = true
      this.column = this.columns2
    },
    onUpItem(record){
      let str1=''
      for(let i=0;i<this.soteData.length;i++){
        if( i > 0 ){
          if(this.soteData[i].id == record.id){
            str1=this.soteData[i]
            this.soteData.splice(i,1)
            this.soteData.splice(i-1,0,str1)
          }
        }
      }
      console.log('this.data1',this.data1)
      console.log('this.soteData',this.soteData)
    },
    onDownItem(record){
      console.log('下移',record,this.soteData)
      for(var i=0;i< this.soteData.length-1;i++){
        if(this.soteData[i].id == record.id){
          var newjson=this.soteData[i+1]
          // console.log('dsd',i,newjson,this.soteData[i],this.soteData[i+1],this.soteData[1],this.soteData)
          this.soteData.splice(i,0,newjson)
          // console.log('dsd',this.soteData)
          this.soteData.splice(i+2,1)
          // console.log(this.soteData)
          return
        }
      }
    },
    handleRankOk(){
      let arr = []
      this.trueArr = []
      for(let item of this.soteData){
        arr.push(item.templateInfoId)
        this.trueArr.push(item)
      }
      // arr = JSON.stringify(arr)
      console.log(arr,'templateInfoId')
      updateSort(arr).then(res=>{
        if(res.code == 0){
          let _this = this
          this.buttonShow = false
          this.column = this.columns
          this.data1 = this.trueArr
          console.log('this.data1',this.data1)
          console.log('this.soteData',this.soteData)
          // 添加页面的数据
          if(this.course == 1){
            getInfoList(this.mdl.templateId).then(res => {
              // console.log(res.data)
              if(res.data == null){
                _this.data1 = []
                _this.installList = []
                _this.soteData = []
              }else{
                for(let i=0;i<res.data.installationInfoList.length;i++){
                  _this.data1.push(res.data.installationInfoList[i])
                }
                this.soteData = res.data.installationInfoList
                // let arrList = []
                // for(let item of _this.data1){
                //   // console.log(item)
                //   arrList.push(item.id)
                // }
                // this.installList = arrList
              }
            })
          }
        }
      })
    },
    handleRankNo(){
      this.buttonShow = false
      console.log('this.data1',this.data1)
      // console.log('this.soteData',this.soteData)
      this.column = this.columns
      this.soteData=[]
      for(let i=0;i<this.data1.length;i++){
        this.soteData.push(this.data1[i])
      }
    },
  }
}
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
  .readyOnly{
    pointer-events: none;
  }
</style>
